import { Typography } from "@mindlercare/ui-web";
import { defaultTheme } from "@mindlercare/ui-web/src/shared/constants";
import { useGetIcbtFeedbacks } from "api/useIcbtQueries";
import { t } from "i18next";
import { styled } from "styled-components";
import { Timestamp } from "./Timestamp";
import { FormContainer, ReplyHeader } from "./sharedFormStyles";

const FeedbackBg = styled.div`
  background-color: ${() => defaultTheme.COLORS.GRAY_LIGHT};
  padding: 10px;
  border-radius: 4px;
`;

const FeedbackText = styled(Typography)`
  white-space: pre-wrap;
`;

const GreySpan = styled.div`
  color: ${() => defaultTheme.COLORS.DARK_GREY};
  font-size: ${() => defaultTheme.FONT.SIZE.SMALL};
  display: flex;
  flex-direction: row;
`;

interface Props {
  userId: number;
  icbtRequestId: string;
}

export const FeedbackHistory = (props: Props) => {
  const { data: feedbacks } = useGetIcbtFeedbacks(props);

  const publishedFeedbacks = feedbacks
    ?.filter((feedback) => feedback.status === "published")
    .sort(
      (a, b) =>
        new Date(b.published_at ?? b.updated_at).getTime() -
        new Date(a.published_at ?? a.updated_at).getTime(),
    );
  if (!publishedFeedbacks || publishedFeedbacks.length < 1) return null;
  return (
    <FormContainer>
      <ReplyHeader variant="body" insensitive>
        {t("SENT_FEEDBACK")}
      </ReplyHeader>
      {publishedFeedbacks?.map((feedback) => (
        <FeedbackBg key={feedback.feedback_id}>
          <FeedbackText variant="body">{feedback.feedback_text}</FeedbackText>
          <br />
          <GreySpan>
            <Timestamp status="sent">
              {feedback.published_at ?? feedback.updated_at}
            </Timestamp>
            {feedback?.name?.firstName && feedback?.name?.lastName && (
              <Typography variant="body-x-small" color="GRAY_DARK">
                &nbsp;{t("BY")} {feedback.name.firstName}{" "}
                {feedback.name.lastName}
              </Typography>
            )}
          </GreySpan>
        </FeedbackBg>
      ))}
    </FormContainer>
  );
};
